import Button from '@mui/material/Button';
import React from 'react';
import styles from './elemLeaderboard.module.css';
import LoadingContext from '../../contexts/LoadingContext';
import LeagueTable from '../../components/LeagueTable';
import ToastContext from '../../contexts/ToastContext';
import { Leaderboard } from '../../types/Leaderboard';
import { backendClient } from '../../services/MtcBackendClient';
import { parseError } from '../../utils/errorUtils';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CompetitonTable from '../../components/CompetitionTable';
import { Competition } from '../../types/Competitions';

const ElementaryLeaderboard: React.FC<any> = ()=>{

    // Contexts
    const { setLoading } = React.useContext(LoadingContext);
    const { openError } = React.useContext(ToastContext);

    // Hooks
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    
    // State
    // const [leaderboard, setLeaderboard] = React.useState<Leaderboard[]>([])
    const [competition, setCompetition] = React.useState<Competition>()
    

    // Handlers
    const handleClose = ()=>{
        // history.goBack();
    }

    // const fetchLeaderbooard = async (id: number)=>{
    //     try {
    //         let data = await backendClient.fetchCompetitionLeaderboard({ competitionId: id } ,setLoading);
    //         console.log(data.data);
    //         setLeaderboard(data.data || []);
    //     } catch (error) {
    //         setLoading(false)
    //         console.log(error);
    //         openError(parseError(error as any))
    //     }
    // }

    const fetchCompetition = async (id: number)=>{
        try {
            let data = await backendClient.fetchCompetitionById(id, {}, setLoading);
            // console.log(data.data);
            setCompetition(data.data)
        } catch (error) {
            setLoading(false)
            console.log(error);
            openError(parseError(error as any))
        }
    }

    // Effect for fetching Leaderboard
    React.useEffect(()=>{
        let competitionId = searchParams.get('cid');

        if (!competitionId) {
            navigate(`/`, { replace: true })
        }
        else{
            fetchCompetition(Number.parseInt(competitionId))
        }
    },[])

    return(
        <div className={styles.main}>
            <div className={styles.title}>
                <h1>CHAMPIONS BOARD</h1>
            </div>
            <div className={styles.container}>
                {/* <LeagueTable 
                    leaderboard={leaderboard}
                /> */}
                <CompetitonTable competition={competition}/>
            </div>
            <div className={styles.buttonArea}>
                <Button
                    onClick={handleClose}
                    sx={{ color: 'white' }}
                >
                    Close
                </Button>
            </div>
        </div>
    )
}

export default ElementaryLeaderboard;